import React from "react";
import * as styles from "./style.module.css";
import Text from "../../Text/Text";
import Icon from "../../Icon/Icon";
const TileWidget = ({ widgetInformation, onWidgetEdit }) => {
  const { identifier, icon } = widgetInformation?.config || {};
  return (
    <div
      className={styles.itemSubWrapper}
      title={identifier}
      onClick={onWidgetEdit}
    >
      <Icon
        src={`images/${icon?.imgName}.svg`}
        alt={identifier}
        width="32px"
        height="32px"
      />
      <Text text={identifier} className="ng_p_1_sb" color="rgb(var(--ng-neutral-60))" />
    </div>
  );
};

export default TileWidget;
